import { render, staticRenderFns } from "./dashDistributorsBiker.vue?vue&type=template&id=61702135&scoped=true&"
import script from "./dashDistributorsBiker.vue?vue&type=script&lang=js&"
export * from "./dashDistributorsBiker.vue?vue&type=script&lang=js&"
import style0 from "./dashDistributorsBiker.vue?vue&type=style&index=0&id=61702135&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61702135",
  null
  
)

export default component.exports